let $popup = $('.popup')
let $body = $('body')
let $html = $('html')

function closePopup()
{
  if($popup.hasClass('popup-visible')) {
    $popup.removeClass('popup-visible')
    $html.removeClass('popup-open')
    $popup.find('.js-popup-content').html('')
    history.pushState({}, null, '/')
  }

}

function openPopup(popupContentID)
{
  let content = $('[data-popup-content="'+popupContentID+'"]')

  if(content.length) {

    $popup.find('.js-popup-content').html(content.html())


    $('.popup .popup-content-container').animate({
      scrollTop : 0
    }, 10);

    $popup.addClass('popup-visible')
    $html.addClass('popup-open')

    history.pushState({}, null, '/#' + popupContentID)
  }

}

$body.on('click', '[data-popup-content-link]', function (e){
  e.preventDefault()
  let popupContentID = $(this).data('popup-content-link')
  openPopup(popupContentID)
})

$body.on('click', '.popup .js-close-popup, .popup .js-background-popup', function (e){
  e.preventDefault()
  closePopup()
})

$(document).keyup(function(e) {
  if (e.key === "Escape" && $popup.is(':visible')) { // escape key maps to keycode `27`
    closePopup()
  }
});

$(window).on('load', function (){
  if(location.hash && location.hash.length > 1) {
    let popupID = location.hash.substring(1)
    let isProduct = popupID.includes("produkts-");
    if(popupID.length > 0 && isProduct) {
      openPopup(popupID)
    }
  }
})

export { closePopup }
